module.exports = __webpack_public_path__ + "img/12.645f0b39.jpg";